import { FC } from 'react';
import styles from './Footer.module.scss';
import { BrandsLogos } from '../../../shared/constants/BrandsLogos';
import Link from 'next/link';

interface FooterProps {
	renderMobile?: boolean;
}

export const Footer: FC<FooterProps> = ({ renderMobile = false }) => {
	if (renderMobile) {
		return (
			<div className={styles['container-mobile']}>
				<div className={styles['logos']}>
					<Link
						tabIndex={0}
						href='https://www.outback.com/seating'
						target='_blank'
						aria-label='outback steak house'
						id={'footer-link-outback'}
					>
						<img
							src={BrandsLogos.outback.black.src}
							alt={BrandsLogos.outback.black.alt}
							id={'img-outback-logo'}
						/>
					</Link>
					<Link
						tabIndex={0}
						href='https://www.carrabbas.com/seating'
						target='_blank'
						aria-label='carrabbas italian grill'
						className={styles['carrabbas-logo']}
						id={'footer-link-carrabbas'}
					>
						<img
							src={BrandsLogos.carrabbas.black.src}
							alt={BrandsLogos.carrabbas.black.alt}
							id={'img-carrabbas-logo'}
						/>
					</Link>
					<Link
						tabIndex={0}
						href='https://www.bonefishgrill.com/reservations'
						target='_blank'
						aria-label='bonefish grill'
						id={'footer-link-bonefish'}
					>
						<img
							src={BrandsLogos.bonefish.black.src}
							alt={BrandsLogos.bonefish.black.alt}
							id={'ing-bonefish-logo'}
						/>
					</Link>
					<Link
						tabIndex={0}
						href='https://www.flemingssteakhouse.com/reservations'
						target='_blank'
						aria-label='flemings prime steak house & wine bar'
						id={'footer-link-fleming'}
					>
						<img
							src={BrandsLogos.flemings.black.src}
							alt={BrandsLogos.flemings.black.alt}
							id={'img-fleming-logo'}
						/>
					</Link>
				</div>
				<div className={styles['copyright']} tabIndex={0}>
					© {new Date().getFullYear()} Bloomin' Brands, Inc. All Rights Reserved.
				</div>
				<div className={styles['linkText']} tabIndex={0}>
					<a aria-label='Do not sell or share my information link' id='one-trust-modal' tabIndex={0}>Do not sell or share my information</a>
				</div>
			</div>
		);
	}

	return (
		<div className={styles['container']}>
			<div className={styles['links']}>
				<a href='/add-a-visit-verify' tabIndex={0} id={'footer-link-missing-points'}>
					Missing Points
				</a>
				|
				<a href='/faqs' tabIndex={0} id={'footer-link-faqs'}>
					FAQs
				</a>
				|
				<a
					href='/terms-and-conditions#privacy-policy'
					tabIndex={0}
					id={'footer-link-Privacy-&-legal-notices'}
				>
					Privacy & Legal Notices
				</a>
				|
				<a
					href='/terms-and-conditions#accessibility'
					tabIndex={0}
					id={'footer-link-accessibility-statement'}
				>
					Accessibility Statement
				</a>
				|
				<a id='one-trust-modal' aria-label='visited, link, Do not sell or share my information' tabIndex={0}>
					Do not sell or share my personal information
				</a>
			</div>
			<div className={styles['logos']}>
				<a
					href='https://www.outback.com/seating'
					target='_blank'
					aria-label='outback steak house'
					tabIndex={0}
					id={'footer-link-outback'}
				>
					<img
						src={BrandsLogos.outback.black.src}
						alt={BrandsLogos.outback.black.alt}
						id={'img-outback-logo'}
					/>
				</a>
				<a
					href='https://www.carrabbas.com/seating'
					target='_blank'
					aria-label='carrabbas italian grill'
					tabIndex={0}
					className={styles['carrabbas-logo']}
					id={'footer-link-carrabbas'}
				>
					<img
						src={BrandsLogos.carrabbas.black.src}
						alt={BrandsLogos.carrabbas.black.alt}
						id={'img-carrabbas-logo'}
					/>
				</a>
				<a
					href='https://www.bonefishgrill.com/reservations'
					target='_blank'
					aria-label='bonefish grill'
					tabIndex={0}
					id={'footer-link-bonefish'}
				>
					<img
						src={BrandsLogos.bonefish.black.src}
						alt={BrandsLogos.bonefish.black.alt}
						id={'img-bonefish-logo'}
					/>
				</a>
				<a
					href='https://www.flemingssteakhouse.com/reservations'
					target='_blank'
					aria-label='flemings prime steak house & wine bar'
					tabIndex={0}
					id={'footer-link-fleming'}
				>
					<img
						src={BrandsLogos.flemings.black.src}
						alt={BrandsLogos.flemings.black.alt}
						id={'img-fleming-logo'}
					/>
				</a>
			</div>
			<div className={styles['copyright']} tabIndex={0} id={'footer-copyright'}>
				© {new Date().getFullYear()} Bloomin' Brands, Inc. All Rights Reserved.
			</div>
		</div>
	);
};
